export default __webpack_public_path__ + "static/media/info.9db56b45.png";